import styled from 'react-emotion/macro';
import { injectGlobal, css } from 'emotion';

const defaultTheme = {
  colors: {
    clientPrimary: '#E2172A',
    clientSecondary: '#377CBE',
    success: '#01BE68',
    local: '#212121',
    dev: '#01BE68',
    staging: '#FFC107',
    production: '#E2172A',
    proceed: '#090',
    reject: '#900',
    info: '#075BAF',
    greyscale: ['#333', '#777', '#AAA', '#DDD', '#F1F1F1', '#FAFAFA', '#FFF'],
    compareArrowUp: '#cc5500',
    compareArrowDown: '#000099',
    events: [
      '#a00', // EVENT_PLAN_PUBLISHED
      '#0a0', // EVENT_OPTIMISATION_STARTED
      '#0a0', // EVENT_OPTIMISATION_ENDED
      '#00a', // EVENT_USER_DATA_CREATION
      '#00a', // EVENT_USER_DATA_DELETION
      '#00a', // EVENT_USER_DATA_UPDATE
      '#a60', // EVENT_INTEGRATION_DATA_CREATION
      '#a60', // EVENT_INTEGRATION_DATA_DELETION
      '#a60', // EVENT_INTEGRATION_DATA_UPDATE
      '#555', // EVENT_SCENARIO_CREATION
      '#00a', // EVENT_USER_DATA_BULK_UPDATE
      '#06a', // EVENT_USER_DATA_UPLOAD
    ],
  },
  space: [5, 10, 15, 30, 45, 60, 75, 90, 100],
  borders: [5, 10, 15, 30, 45, 60, 75, 90, 100],
  widths: [0.10, 0.25, 0.33, 0.5, 0.75, 1],
  fontSizes: [8, 10, 12, 14, 16, 21, 32, 48, 64, 96],
  heights: {
    navBarHeight: '64px',
  },
};

export default defaultTheme;

// eslint-disable-next-line
const injectGlobalStyles = () => injectGlobal`
  html {
    height: 100%;
  }
  body {
    font-family: 'proxima-nova', Sans-Serif;
    height: 100%;
    margin: 0;
    overflow: hidden;
  }

  #root {
    height: 100%;
    background-color: ${defaultTheme.colors.greyscale[5]};
    display: flex;
    flex-direction: column;
  }

  .recharts-cartesian-axis-tick text {    
    font-size: 1.4rem;
    color: #aaa;
    font-weight: lighter;
    letter-spacing: 1px;
    font-family: 'proxima-nova', sans-serif;
  }

  .colour-content-container > .chrome-picker,
  .colour-content-container > div > div,
  .DCRPCompactColourPicker .ant-popover-inner-content > div > div { /* thats for the Form/color-adjust.js */
    box-shadow: none !important;
  }
`;

injectGlobalStyles();


export const bouncyBoyMixin = css`
  transition: transform 0.1s, box-shadow 0.25s;
  user-select: none;
  &:focus {
    outline: 0;
    /* TODO: We'll need something here for a11y */
    /* border: 1px ${defaultTheme.colors.clientPrimary} solid; */
    /* box-shadow: 4px 4px 6px 0px ${defaultTheme.colors.greyscale[2]}; */
  }
  &:hover {
    border: 0;
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const clipTextMixin = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;  
`;

export const InlineSpinner = styled('div')`
  display: flex;
  color: #aaa;
  font-size: 0.9em;
  margin-right: 4em;
  span {
    margin-left: 0.5em;
    text-transform: uppercase;
    font-weight: bold;
  }
`;
